export default "__VITE_ASSET__yzt9qtzt__"